import React from 'react'
import { DetailsRow } from '../DetailsRow'
import { DetailsColumn } from '../DetailsColumn'
import { FieldsRow } from '../FieldsRow'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { toDisplayDateTime } from 'utils/date'
import styles from './DeliveryPointDetails.module.css'
import { ReadOnlyCheckbox } from 'components/Shared/ReadOnlyCheckbox'
import { getLabelFromArrayByParameter } from 'components/Order/OrderDetails/Utils'
import optionalFeatures from 'components/Order/orderOptionalFeatures.json'
import { useTranslation } from 'react-i18next'
import Sections from 'components/Order/sections'
import { uniq } from 'lodash'

export function LoadingDeliveryPointDetails (props) {
  return <DeliveryPointDetails section={Sections.Loading} {...props}/>
}

export function UnloadingDeliveryPointDetails (props) {
  return <DeliveryPointDetails section={Sections.Unloading} {...props}/>
}

function DeliveryPointDetails ({ deliveryPoint, diffValues, section }) {
  const { t } = useTranslation()

  return (
    <DetailsRow section={section}>
      <DetailsColumn>
        <ReadOnlyTextField label={'order.details.deliveryPoint.companyName'}
                           value={deliveryPoint.companyName}
                           previousValue={diffValues && { value: diffValues.companyName }}
        />
        <FieldsRow>
          <ReadOnlyTextField label={'order.details.deliveryPoint.fromDate'}
                             InputClass={styles.dateFieldInput}
                             value={toDisplayDateTime(deliveryPoint.fromDateTime)}
                             previousValue={diffValues && { value: toDisplayDateTime(diffValues.fromDateTime) }}
          />
          <ReadOnlyTextField label={'order.details.deliveryPoint.toDate'}
                             InputClass={styles.dateFieldInput}
                             value={toDisplayDateTime(deliveryPoint.toDateTime)}
                             previousValue={diffValues && { value: toDisplayDateTime(diffValues.toDateTime) }}
          />
        </FieldsRow>
        <ReadOnlyTextField label={'order.details.deliveryPoint.address'}
                           value={deliveryPoint.address}
                           previousValue={diffValues && { value: diffValues.address }}
        />
        <ReadOnlyTextField label={'order.details.deliveryPoint.cityName'}
                           value={deliveryPoint.cityName}
                           previousValue={diffValues && { value: diffValues.cityName }}
        />
        <FieldsRow>
          <ReadOnlyTextField label={'order.details.deliveryPoint.country'}
                             value={t(`countries.${deliveryPoint.country}`)}
                             previousValue={diffValues && { value: t(`countries.${diffValues.country}`) }}
          />
          <ReadOnlyTextField label={'order.details.deliveryPoint.zipCode'}
                             value={deliveryPoint.zipCode}
                             previousValue={diffValues && { value: diffValues.zipCode }}
          />
        </FieldsRow>
      </DetailsColumn>
      <DetailsColumn>
        <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.name'}
                           value={deliveryPoint.cargoDetails.name}
                           previousValue={diffValues && { value: diffValues.cargoDetails.name }}
        />
        <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.wrappingType'}
                           value={deliveryPoint.cargoDetails.wrappingType}
                           previousValue={diffValues && { value: diffValues.cargoDetails.wrappingType }}
        />
        <FieldsRow>
          <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.quantity'}
                             value={deliveryPoint.cargoDetails.quantity}
                             previousValue={diffValues && { value: diffValues.cargoDetails.quantity }}
          />
          <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.weight'}
                             value={deliveryPoint.cargoDetails.weight}
                             previousValue={diffValues && { value: diffValues.cargoDetails.weight }}
          />
        </FieldsRow>
        <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.dispenser'}
                           value={deliveryPoint.cargoDetails.dispenser}
                           previousValue={diffValues && { value: diffValues.cargoDetails.dispenser }}
        />
        <ReadOnlyTextField label={'order.details.deliveryPoint.cargo.additionalInfo'}
                           value={deliveryPoint.additionalInfo}
                           previousValue={diffValues && { value: diffValues.additionalInfo }}
                           multiline/>
      </DetailsColumn>
      <DetailsColumn>
        {t('order.details.deliveryPoint.cargo.optionalFeatures.title')}
        {uniq(deliveryPoint.optionalFeatures.concat(diffValues?.optionalFeatures || [])).map(feature =>
          <ReadOnlyCheckbox
            key={feature}
            checked={deliveryPoint.optionalFeatures.includes(feature)}
            diffValue={diffValues?.optionalFeatures?.includes(feature)}
            label={
              'order.details.deliveryPoint.cargo.optionalFeatures.' +
              t(getLabelFromArrayByParameter(feature, optionalFeatures, 'id'))}
          />
        )}
      </DetailsColumn>
    </DetailsRow>
  )
}
